export default __webpack_public_path__ + "static/media/eraser.ef2b232c.svg";